import React, { useState, useEffect } from 'react';
import { coins } from '../../utils/api';
import { useAuth } from '../../context/AuthContext';
import { formatDate } from '../../utils/dateUtils';

const PopulationInfo = ({ coin }) => {
  const { user } = useAuth();
  const [history, setHistory] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchHistory = async () => {
      try {
        setLoading(true);
        const data = await coins.getPopulationHistory(coin.id);
        setHistory(data);
      } catch (err) {
        console.error('Error fetching population history:', err);
      } finally {
        setLoading(false);
      }
    };

    if (coin.id) {
      fetchHistory();
    }
  }, [coin.id]);
  return (
    <div className="bg-white rounded-lg shadow-sm border border-gray-200">
      <div className="px-4 py-5 sm:px-6 border-b border-gray-200 bg-gray-50">
        <h3 className="text-lg font-medium leading-6 text-gray-900">Population Information</h3>
      </div>
      <dl className="divide-y divide-gray-200">
        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Pop. (Bought)</dt>
          <dd className="text-sm text-gray-900 my-auto">
            {coin.population_when_bought ?? 0}
          </dd>
        </div>

        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Pop. (Current)</dt>
          <dd className="text-sm text-gray-900 my-auto">
            {coin.current_population ?? 0}
          </dd>
        </div>

        <div className="bg-white px-4 py-3 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Pop. Higher (Bought)</dt>
          <dd className="text-sm text-gray-900 my-auto">
            {coin.pop_higher_when_bought ?? 0}
          </dd>
        </div>

        <div className="bg-gray-50 px-4 py-3 sm:grid sm:grid-cols-4 sm:gap-4 sm:px-6">
          <dt className="text-sm font-medium text-gray-500 my-auto sm:col-span-3">Pop. Higher (Current)</dt>
          <dd className="text-sm text-gray-900 my-auto">
            {coin.current_pop_higher ?? 0}
          </dd>
        </div>

        {coin.pcgs_number && (
          <div className="bg-white px-4 pt-2 pb-3 sm:px-6 flex flex-col" style={{ height: '350px' }}>
            <div className="text-center mb-2">
              <a 
                href={`https://www.pcgs.com/coinfacts/coin/detail/${coin.pcgs_number}`}
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 text-sm"
              >
                View Full Details
              </a>
            </div>
            <div className="overflow-y-auto flex-grow">
              {loading ? (
                <div className="text-sm text-gray-500 text-center">Loading history...</div>
              ) : (
                history.map(record => (
                  <div key={record.id} className="text-sm text-gray-600 mb-1 hover:bg-gray-50 py-0.5 px-1 rounded">
                    {formatDate(record.created_at, { user, includeTime: true })}: {record.new_population ?? 0}/{record.new_population_higher ?? 0}
                  </div>
                ))
              )}
            </div>
          </div>
        )}
      </dl>
    </div>
  );
};

export default PopulationInfo;
